<template>
    <a-modal
        title="分配简历"
        :visible="visible"
        class="modal-initialize"
        width="588px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">

                    <a-form-item
                        label="客户经理"
                        v-bind="formItemLayout"
                        labelAlign="left"
                    >
                        <a-select
                            v-decorator="['mid', {required: true, rules: [{ message: '选择客户经理' }], initialValue: ''}]">>
                            <a-select-option value="">选择客户经理</a-select-option>
                            <template v-for="(item, key) in config.manager">
                                <a-select-option :key="key" :value="item[0]" v-if="item[0].charAt(0) != 'G'">
                                    {{ item[1] }}
                                </a-select-option>
                                <a-select-option v-else :key="key" :value="item[0]" :disabled="true">
                                    {{ item[1] }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-item>

                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            config: {},
            dateFormat: 'YYYY-MM',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {
            let data = {};
            data.vid = this.vid;

            this.http('/manage/resume/info', data, (res) => {

                this.config = res.config;

            }, null, 1);
        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        // console.log(values);return;

                        let url = '/manage/resume/assign';
                        values.rid = this.rid;

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
    }
}
</script>